import api from "lib/api";

const GET_COMMON_TYPE_LINK = "/v1/dropdown/getCommonTypeByGroupType";

export const getWelfareList = async (params = {}) => {
  return await api.post("/v1/welfare/getWelfarePaging", params);
};

export const getWelfareType = async () => {
  return await api.post(GET_COMMON_TYPE_LINK, {
    groupType: "WELFARE_TYPE",
  });
};

export const getWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/getWelfare", params);
};

export const createWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/createWelfare", params);
};

export const updateWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/updateWelfare", params);
};

export const manageStatusWelfare = async (params = {}) => {
  return await api.post("/v1/welfare/manageStatusWelfare", params);
};

export const getWelfareCategory = async (params = {}) => {
  return await api.post("/v1/dropdown/getWelfareCategoryByGroupTypeCode", params);
};

export const getWelfareSubType = async (params = {}) => {
  return await api.post("/v1/dropdown/getWelfareSubTypeByCode", params);
};

export const getRecipient = async (params = {}) => {
  return await api.post("/v1/dropdown/getRecipientByCode", params);
};

export const getEmployeeByPositionIdDropdown = async (params = {}) => {
  return await api.post("/v1/welfare/dropdownEmployeeByPositionId", params);
};

export const getIncomeByCompany = async (params = {}) => {
  return await api.post("/v1/dropdown/getIncomeByCompany", params);
};

export const getDeductionByCompanyId = async (params = {}) => {
  return await api.post("/v1/dropdown/getDeductionByCompanyId", params);
};

export const getWorkFlowByTypeWelfare = async (params = {}) => {
  return await api.post("/v1/workFlowMapping/getWorkFlowByType", params);
};